<template>
  <PubPage showProject @changeProject="changeProject">
    <BasicTable
      :columns="columns"
      bordered
      :dataSource="list"
      :loading="loading"
      boxShadow
      :pagination="{
        current: form.paging.page,
        pageSize: form.paging.limit,
        total: pageTotal,
      }"
      @searchBack="searchBack"
      @pagesChange="pagesChange"
    >
      <template #tableTitle>
        <div class="pub-tableTitle-button">
          <a-button
            type="primary"
            class="btn-blue"
            icon="plus-circle"
            @click="add('add')"
            >添加教师</a-button
          >
          <PubImportFile
            btnText="导入教师"
            businessType="PERSONNEL_CONTRACT"
            @uploadOk="uploadOk"
            :loading="importLoading"
          />
          <a
            href="https://image.91zhkj.com/schoolFaceFile/template/%E5%AF%BC%E5%85%A5%E6%95%99%E5%B8%88%E4%BA%BA%E5%91%98%E6%A8%A1%E7%89%88.xlsx"
            download="导入教师模板"
            target="_blank"
            >下载模板</a
          >
        </div>
      </template>
      <template slot="index" slot-scope="{ index }">
        {{ index + 1 }}
      </template>
      <template slot="avatarUrl" slot-scope="{ record }">
        <FaceImg :dataSource="record.faceFileList" />
      </template>
      <template slot="syncStatus" slot-scope="{ record }">
        <div
          :style="{
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'center',
          }"
        >
          <PubStatus :status="record.syncStatus" type="SYNC_STATUS" />
          <a-popover
            v-if="record.syncStatus == '1' && record.errorMsg"
            title="异常原因"
          >
            <template slot="content">
              {{ record.errorMsg }}
            </template>

            <a-icon
              :style="{ 'margin-left': '5px' }"
              type="question-circle"
              theme="twoTone"
              two-tone-color="#eb2f96"
            />
          </a-popover>
        </div>
      </template>
      <template slot="sex" slot-scope="{ record }">
        <PubStatus :status="record.sex" type="SEX_STATUS" />
      </template>
      <template slot="status" slot-scope="{ record }">
        <PubEnableStatus :status="record.status" />
      </template>

      <template slot="options" slot-scope="{ record }">
        <div class="pub-options">
          <a @click="add('edit', record)"> <a-icon type="form" />编辑 </a>
          <a @click="deleteCustomer(record.id)" class="red">
            <a-icon type="delete" />删除
          </a>
        </div>
      </template>
    </BasicTable>
    <AddModal ref="addModalModal" @ok="moduleOk" />
  </PubPage>
</template>

<script>
import { Teacher } from "@/api";
import AddModal from "./AddModal.vue";
import PubImportFile from "@/components/PubImportFile";
import FaceImg from "@/components/PublicModals/FaceImg";
export default {
  components: {
    AddModal,
    PubImportFile,
    FaceImg,
  },
  data() {
    const columns = [
      {
        title: "序号",
        dataIndex: "index",
        align: "center",
        width: 50,
        hideInSearch: true,
        scopedSlots: true,
      },
      {
        title: "人脸照片",
        dataIndex: "avatarUrl",
        align: "center",
        scopedSlots: true,
        hideInSearch: true,
        width: 100,
      },
      {
        title: "姓名",
        dataIndex: "name",
      },
      {
        title: "性别",
        dataIndex: "sex",
        scopedSlots: true,
        hideInSearch: true,
      },
      {
        title: "班级",
        dataIndex: "gradeClassName",
        hideInSearch: true,
      },
      {
        title: "班级",
        dataIndex: "gradeClassId",
        align: "center",
        hideInTable: true,
        valueType: "select",
        fieldProps: {
          placeholder: "请选择班级",
          option: () =>
            this.common.getAllClass(this.$store.state.user.schoolId),
        },
      },
      {
        title: "手机号",
        dataIndex: "telephone",
      },
      {
        title: "同步状态",
        dataIndex: "syncStatus",
        scopedSlots: true,
        width: 120,
        align: "center",
        valueType: "select",
        fieldProps: {
          placeholder: "请选择同步状态",
          option: () => this.common.findSysCodeType("SYNC_STATUS"),
        },
      },
      {
        title: "状态",
        dataIndex: "status",
        align: "center",
        scopedSlots: true,
        valueType: "select",
        width: 100,
        fieldProps: {
          placeholder: "请选择状态",
          option: () => this.common.findSysCodeType("SYS_STATUS"),
        },
      },
      {
        title: "操作",
        align: "center",
        width: 130,
        dataIndex: "options",
        hideInSearch: true,
        scopedSlots: true,
      },
    ];
    return {
      form: {
        paging: {
          page: 1,
          limit: 20,
          sort: [
            {
              property: "createTime",
              direction: "DESC",
            },
          ],
        },
      },
      list: [],
      pageTotal: 0,
      loading: false,
      importLoading: false,
      columns,
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 切换学校
    changeProject() {
      this.form.schoolId = this.$store.state.user.schoolId;
      this.form.paging.page = 1;
      this.columns = [...this.columns];
      this.getList();
    },
    // 获取数据
    getList() {
      this.loading = true;
      Teacher.teacherBasicPage(this.form).then(res => {
        if (res.code == this.config.pubCode) {
          this.list = res.data;
          this.pageTotal = res.total;
        }
        this.loading = false;
      });
    },
    // 翻页回调
    pagesChange(data) {
      this.form.paging.page = data.current;
      this.form.paging.limit = data.pageSize;
      this.getList();
    },
    // 搜索回调
    searchBack(data) {
      data.paging = {
        page: 1,
        limit: this.form.paging.limit,
      };
      this.form = { ...this.form, ...data };
      this.getList();
    },
    // 删除
    deleteCustomer(id) {
      this.pubMsg.confirm("是否确定删除此数据？").then(() => {
        this.loading = true;
        Teacher.teacherBasicDelete({ ids: id }).then(res => {
          if (res.code == this.config.pubCode) {
            this.pubMsg.tipMessage("删除成功！", "success");
            this.getList();
          }
          this.loading = false;
        });
      });
    },
    // 上传结束
    uploadOk(data) {
      this.importLoading = true;
      Teacher.teacherBasicImportFile({
        schoolId: this.form.schoolId,
        sysFile: data,
      }).then(res => {
        if (res.code == this.config.pubCode) {
          this.pubMsg.tipMessage("导入成功！", "success");
          this.getList();
        }
        this.importLoading = false;
      });
    },

    add(type, data) {
      this.$refs.addModalModal.open(type, data);
    },
    moduleOk(data) {
      if (data) {
        this.getList();
      }
    },
  },
};
</script>
